module.exports = __webpack_public_path__ + "img/servicesSWAP.639fcb76.png";